import type { Schema } from "../../..";
import type { Parser } from "../parser";

export class ModuleCateogiresParser implements Parser {
	parse(schema: Schema.ModuleCategories) {
		return schema
			? `export type ModuleCategories = ${schema
					.map((entry) => `"${entry.value}"`)
					.join("|")}`
			: "";
	}
}
